import { AddProductToCartResult } from '../../../graphql/cart/addProductToCart';
import { AddToCurrentCartFailedError } from '../../carts/CartsState';
import { CustomOrderType } from '../../carts/CustomOrderType';
import { createAction } from '@reduxjs/toolkit';

export interface ApiCartAddToCartRequestedPayloadTracking {
  readonly itemListId?: string;
  readonly itemListName?: string;
}

export interface ApiCartAddToCartRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly parentActionId: number;
  readonly productCode: string;
  readonly quantity: number;
  readonly storeCode?: string;
  readonly tracking?: ApiCartAddToCartRequestedPayloadTracking;
}
export const apiCartAddToCartRequestedType = 'api/cart/addToCart--requested';
export const apiCartAddToCartRequested = createAction<ApiCartAddToCartRequestedPayload>(
  apiCartAddToCartRequestedType
);
export type ApiCartAddToCartRequestedAction = ReturnType<typeof apiCartAddToCartRequested>;

export interface ApiCartAddToCartSucceededPayload {
  readonly cartId: string | null;
  readonly parentActionId: number;
  readonly productCode: string;
  readonly quantity: number;
  readonly requestedActionId: number;
  readonly result: AddProductToCartResult;
  readonly sourceCustomOrderType: CustomOrderType;
  readonly targetCustomOrderType: CustomOrderType;
}
export const apiCartAddToCartSucceededType = 'api/cart/addToCart--succeeded';
export const apiCartAddToCartSucceeded = createAction<
  ApiCartAddToCartSucceededPayload,
  typeof apiCartAddToCartSucceededType
>(apiCartAddToCartSucceededType);
export type ApiCartAddToCartSucceededAction = ReturnType<typeof apiCartAddToCartSucceeded>;

export interface ApiCartAddToCartFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
  readonly failedReason: AddToCurrentCartFailedError;
}
export const apiCartAddToCartFailedType = 'api/cart/addToCart--failed';
export const apiCartAddToCartFailed = createAction<
  ApiCartAddToCartFailedPayload,
  typeof apiCartAddToCartFailedType
>(apiCartAddToCartFailedType);
export type ApiCartAddToCartFailedAction = ReturnType<typeof apiCartAddToCartFailed>;
